import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useNavigate } from 'react-router-dom';
import { Categories } from '../Data/Categories';
import CategoriesSliderDiv from './CategoriesSliderDIv';

function CategoriesSlider() {
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1220 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1220, min: 842 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 842, min: 0 },
            items: 1
        }
    };

    const navigate = useNavigate();
    function navigatetocategory(name) {
        navigate('/search', { state: { name } });
    }

    return (
        <div className="Categories">
            <h1 className='Ch1' id='Categories-h1'>Categories</h1>
            <Carousel responsive={responsive} showArrows={true}>
                {Categories.map((item, index) => (
                    <CategoriesSliderDiv key={index} name={item} index={index}/>
                ))}
            </Carousel>
        </div>
    );
}

export default CategoriesSlider;
